// utils/networkNames.ts

export const networkNames: Record<number, string> = {
    // Ethereum Mainnets & Testnets
    1: 'Ethereum Mainnet',
    3: 'Ropsten Testnet',
    4: 'Rinkeby Testnet',
    5: 'Goerli Testnet',
    42: 'Kovan Testnet',
    11155111: 'Sepolia Testnet',
  
    // Polygon
    137: 'Polygon Mainnet',
    80001: 'Mumbai Testnet',
  
    // Arbitrum
    42161: 'Arbitrum One',
    421613: 'Arbitrum Goerli',
  
    // Optimism
    10: 'Optimism Mainnet',
    420: 'Optimism Goerli',
  
    // Avalanche
    43114: 'Avalanche C-Chain',
    43113: 'Avalanche Fuji Testnet',
  
    // Binance Smart Chain
    56: 'BNB Smart Chain Mainnet',
    97: 'BNB Testnet',
  
    // Fantom
    250: 'Fantom Opera',
    4002: 'Fantom Testnet',
  
    // Base
    8453: 'Base Mainnet',
    84531: 'Base Goerli',
  
    // Gnosis
    100: 'Gnosis Chain',
  
    // Custom Chains
    2477: '6DO Chain',
    24772477: '6DO Chain - Testnet',
  };
  
  export function getNetworkNameById(id: number): string {
    return networkNames[id] || `Unknown Network (Chain ID: ${id})`;
  }
  